"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.variant = exports.alpha = exports.palette = exports.themed = undefined;

var _themed = require("./themed");

Object.defineProperty(exports, "themed", {
  enumerable: true,
  get: function () {
    return _interopRequireDefault(_themed).default;
  }
});

var _color = require("color");

var _color2 = _interopRequireDefault(_color);

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const palette = exports.palette = (p, path) => (0, _lodash.get)(p.theme.colors.palette, path);
const alpha = exports.alpha = (color, alpha) => (0, _color2.default)(color).alpha(alpha).rgb().string();

const variant = exports.variant = (p, thing) => thing[p.variant];